/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import classnames from "classnames";
// reactstrap components
import {
  Button,
  Card,
  Container,
  Row,
  Col,
  Badge,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Progress,
  UncontrolledCarousel,
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import Carousel from "views/IndexSections/Carousel";
const items = [
  {
    src: require("assets/img/theme/DCXIdeathon_Mahesh_Bhusanoor_Capgemini.png"),
    altText: "Mahesh Bhusanoor",
    caption: "Mahesh Bhusanoor",
    header: "Mahesh Bhusanoor",
  },
  {
    src: require("assets/img/theme/Mahesh bhusanoor Coimbture Workshop.jpg"),
    altText: "Mahesh Bhusanoor",
    caption: "Mahesh Bhusanoor",
    header: "Mahesh Bhusanoor",
  },
  {
    // src: require("assets/img/theme/Mahesh Bhusanoor Kerala workshop.jpg"),
    altText: "Mahesh Bhusanoor",
    caption: "",
    header: "",
  },
  {
    // src: require("assets/img/theme/Mahesh Bhusanoor Loyala Institute Workshop.jpg"),
    altText: "Mahesh Bhusanoor",
    caption: "Mahesh Bhusanoor",
    header: "Mahesh Bhusanoor",
  },
  // {
  //   src: require("assets/img/theme/IIT_Bombay.jpg"),
  //   altText: "Mahesh Bhusanoor",
  //   caption: "",
  //   header: ""
  // },
];
const emailValidation = (value) => {
  return new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(value);
};
class Profile extends React.Component {
  state = {};
  // emailValidation = (value) => {
  //   return new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(value);
  // }
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
    this.state.experience = this.calculate_age("06/02/2014");
    this.state.message = "";
    this.state.name = "";
    this.state.email = "";
  }

  calculate_age = (dob) => {
    const birthDate = new Date(dob);
    const difference = Date.now() - birthDate.getTime();
    const age = new Date(difference);

    return Math.abs(age.getUTCFullYear() - 1970);
  };

  submitQuery = () => {
    if (this.state.name == "") {
      alert("Name should not be blank");
      return true;
    }
    if (this.state.email == "") {
      alert("Email id should not be blank");
      return true;
    }
    if (!emailValidation(this.state.email)) {
      alert("Email id is not valid");
      return true;
    }
    if (this.state.message == "") {
      alert("Message should not be blank");
      return true;
    }
    fetch(
      "https://us-central1-mahesh-virus.cloudfunctions.net/sendMail?name=" +
        this.state.name +
        "&message=" +
        this.state.message +
        "&email=" +
        this.state.email +
        ""
    )
      .then((res) => res.json())
      .then(
        (result) => {
          // this.setState({
          //   isLoaded: true,
          //   items: result.items
          // });

          this.setState({ name: "" });
          this.setState({ message: "" });
          this.setState({ email: "" });
          alert("Thank You!!");
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          // this.setState({
          //   isLoaded: true,
          //   error
          // });

          this.setState({ name: "" });
          this.setState({ message: "" });
          this.setState({ email: "" });
          alert("Thank You!!");
        }
      );
  };

  render() {
    return (
      <>
        <DemoNavbar />
        <main className="profile-page" ref="main">
          <section className="section-profile-cover section-shaped my-0 ">
            {/* Circles background */}
            <div className="shape shape-style-1 shape-default alpha-4">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>
          <section className="section">
            <Container>
              <Card className="card-profile shadow mt--300">
                <div className="px-4">
                  <Row className="justify-content-center">
                    <Col className="order-lg-2" lg="12">
                      <div className="card-profile-image floating">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="rounded-circle"
                            src={require("assets/img/theme/Mahesh-Bhusanoor.jpg")}
                          />
                        </a>
                      </div>
                    </Col>
                    {/* <Col
                      className="order-lg-3 text-lg-right align-self-lg-center"
                      lg="4"
                    >
                      <div className="card-profile-actions py-4 mt-lg-0">
                        <Button
                          className="mr-4"
                          color="info"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                          size="sm"
                        >
                          Connect
                        </Button>
                        <Button
                          className="float-right"
                          color="default"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                          size="sm"
                        >
                          Message
                        </Button>
                      </div>
                    </Col>
                    <Col className="order-lg-1" lg="4">
                      <div className="card-profile-stats d-flex justify-content-center">
                        <div>
                          <span className="heading">22</span>
                          <span className="description">Friends</span>
                        </div>
                        <div>
                          <span className="heading">10</span>
                          <span className="description">Photos</span>
                        </div>
                        <div>
                          <span className="heading">89</span>
                          <span className="description">Comments</span>
                        </div>
                      </div>
                    </Col> */}
                  </Row>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <div className="text-center mt-5">
                    <h3>
                      Mahesh Bhusanoor{" "}
                      {/* <span className="font-weight-light">, 27</span> */}
                    </h3>
                    {/* <div>
                      <i className="ni education_hat mr-2" />
                      {"<Maheshvirus>"}
                    </div> */}
                    {/* <div className="h6 font-weight-300">
                      <i className="ni location_pin mr-2" />
                      BE- Computer Engineering
                    </div> */}
                    <div className="h6 mt-4">
                      <i className="ni business_briefcase-24 mr-2" />
                      Mobile Web Specialist
                    </div>
                    <div>
                      <i className="ni education_hat mr-2" />
                      Technical Lead At Capgemini UAE - Dubai
                    </div>
                  </div>
                  <br />
                  {/* <div className="mt-5 py-5 border-top text-center">
                    <Row className="justify-content-center">
                      <Col lg="9">
                        <p>
                          {this.calculate_age("06/02/2014")}+ years of
                          experience in Android, IOS, Web, Azure Cloud, Docker,
                          Kubernates, DevOps, BFF, Portal, and PWA.
                        </p>
                        <a href="#pablo" onClick={e => e.preventDefault()}>
                          Show more
                        </a>
                      </Col>
                    </Row>
                  </div> */}
                </div>
              </Card>
            </Container>
          </section>
        </main>
        {/* <Carousel /> */}
        <Carousel />
        <section className="section section-lg">
          <Container>
            <Row className="row-grid align-items-center">
              <Col className="order-md-2" md="6">
                <img
                  alt="Mahesh_Bhusanoor_Hilton_Hotel_Malaysia"
                  className="img-fluid floating"
                  src={require("assets/img/theme/Mahesh_Bhusanoor_Hilton_Hotel_Malaysia.jpg")}
                />
                <br /> <br />
                <p className="text-center">
                  A beautiful gesture of love from{" "}
                  <b>
                    <a href="https://www3.hilton.com/en/hotels/malaysia/hilton-petaling-jaya-PETHITW/index.html?WT.mc_id=zELWAKN0APAC1HI2DMH3LocalSearch4DGGenericx6PETHITW">
                      Hilton Petaling Jaya, Malaysia.
                    </a>
                  </b>
                </p>
              </Col>
              <Col className="order-md-1" md="6">
                <div className="pr-md-5">
                  <div className="icon icon-lg icon-shape icon-shape-success shadow rounded-circle mb-5">
                    <i className="ni ni-satisfied" />
                  </div>
                  <h3>Hi! I'm Mahesh Bhusanoor</h3>
                  <p>
                    I hold {this.calculate_age("06/02/2014")}+ years of
                    experience in Mobile, Web, Azure, Docker, Kubernates,
                    NodeJs, DevOps, BFF, Portal, and PWA.
                  </p>
                  {/* <p>
                    Skilled in React-Native, React JS, Redux (Thunk, SAGA &
                    Observables), Ionic, Capacitor, Node JS, Express Js, DevOps,
                    Azure, CICD, AWS, Java, Docker, Kubernates, Android Native,
                    PhoneGap/Cordova, MongoDB, IBM Mobile First, JavaScript,
                    Firebase, Typescript and Angular2+.
                  </p> */}
                  <p>
                    <a href="https://stackexchange.com/users/5859243">
                      <img
                        src="https://stackexchange.com/users/flair/5859243.png"
                        width="208"
                        height="58"
                        alt="profile for Maheshvirus on Stack Exchange, a network of free, community-driven Q&amp;A sites"
                        title="profile for Maheshvirus on Stack Exchange, a network of free, community-driven Q&amp;A sites"
                      />
                    </a>
                  </p>
                  {/* <p>Moto of Life - <b>Do one thing every day that scares you.</b></p> */}
                  <p>
                    Moto of Life -{" "}
                    <a
                      className="font-weight-bold text-warning mt-5"
                      // href="#pablo"
                      // onClick={e => e.preventDefault()}
                    >
                      Do one thing every day that scares you.
                    </a>
                  </p>
                  <ul className="list-unstyled mt-5">
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-satisfied" />
                          </Badge>
                        </div>
                        <div>
                          <h6 className="mb-0">Mobile Technologies</h6>
                        </div>
                      </div>
                      <p>
                        React-Native, Ionic, Capacitor, Android Native, Cordova,
                        Fastlane.
                      </p>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-satisfied" />
                          </Badge>
                        </div>
                        <div>
                          <h6 className="mb-0">Front-End Technologies</h6>
                        </div>
                      </div>
                      <p>
                        React JS, Redux, TypeScript, JavaScript, Angular JS,
                        HTML, CSS, Bootstrap.
                      </p>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-satisfied" />
                          </Badge>
                        </div>
                        <div>
                          <h6 className="mb-0">Back-End Technologies</h6>
                        </div>
                      </div>
                      <p>Node Js, Express Js, MongoDB, IBM Mobile First.</p>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-satisfied" />
                          </Badge>
                        </div>
                        <div>
                          <h6 className="mb-0">DevOps & Cloud Technologies</h6>
                        </div>
                      </div>
                      <p>
                        Azure, AWS, Docker, Kubernates, CICD, Bitrise, Jenkins,
                        SonarQube.
                      </p>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-satisfied" />
                          </Badge>
                        </div>
                        <div>
                          <h6 className="mb-0">Digital Marketing</h6>
                        </div>
                      </div>
                      <p>
                        Exponea, Adjust, Firebase & Google Analytics, GTM, SEO,
                        Google AdWords and Google AdSense.
                      </p>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-satisfied" />
                          </Badge>
                        </div>
                        <div>
                          <h6 className="mb-0">Monitoring & Deployments</h6>
                        </div>
                      </div>
                      <p>
                        Firebase, Sentry, DataDog, Play Store, App Store, Jest,
                        Enzyme and karma-Jasmine.
                      </p>
                    </li>
                    {/* <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-satisfied" />
                          </Badge>
                        </div>
                        <div>
                          <h6 className="mb-0">
                            Technical Trainings and Blogs
                          </h6>
                        </div>
                      </div>
                    </li> */}
                  </ul>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col lg="12">
                <Row className="row-grid">
                  <Col lg="4">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        {/* <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                          <i className="ni ni-check-bold" />
                        </div> */}
                        {/* <h6 className="text-primary text-uppercase">
                          Download Argon
                          </h6> */}
                        {/* <p className="description mt-3">
                          Argon is a great free UI package based on Bootstrap
                          4 that includes the most important components and
                          features.
                          </p>
                        <div>
                          <Badge color="primary" pill className="mr-1">
                            design
                            </Badge>
                          <Badge color="primary" pill className="mr-1">
                            system
                            </Badge>
                          <Badge color="primary" pill className="mr-1">
                            creative
                            </Badge>
                        </div>
                        <Button
                          className="mt-4"
                          color="primary"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Learn more
                          </Button> */}
                        <div className="progress-wrapper">
                          <div className="progress-info">
                            <div className="progress-label">
                              <span>Mobile Technologies</span>
                            </div>
                            <div className="progress-percentage">
                              <span>85%</span>
                            </div>
                          </div>
                          <Progress max="100" value="85" color="primary" />
                        </div>
                        <div className="progress-wrapper">
                          <div className="progress-inpfo">
                            <div className="progress-label">
                              <span>Front-End Technologies</span>
                            </div>
                            <div className="progress-percentage">
                              <span>80%</span>
                            </div>
                          </div>
                          <Progress max="100" value="90" color="info" />
                        </div>
                        {/* <div className="progress-wrapper">
                          <div className="progress-info">
                            <div className="progress-label">
                              <span>Front-End Technologies</span>
                            </div>
                            <div className="progress-percentage">
                              <span>80%</span>
                            </div>
                          </div>
                          <Progress max="100" value="80" color="success" />
                        </div> */}
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="4">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <div className="progress-wrapper">
                          <div className="progress-info">
                            <div className="progress-label">
                              <span>Back-End Technologies</span>
                            </div>
                            <div className="progress-percentage">
                              <span>70%</span>
                            </div>
                          </div>
                          <Progress max="100" value="90" color="primary" />
                        </div>
                        <div className="progress-wrapper">
                          <div className="progress-inpfo">
                            <div className="progress-label">
                              <span>Digital Marketing</span>
                            </div>
                            <div className="progress-percentage">
                              <span>80%</span>
                            </div>
                          </div>
                          <Progress max="100" value="90" color="info" />
                        </div>
                        {/* <div className="progress-wrapper">
                          <div className="progress-info">
                            <div className="progress-label">
                              <span>TypeScript/Angular 2+</span>
                            </div>
                            <div className="progress-percentage">
                              <span>80%</span>
                            </div>
                          </div>
                          <Progress max="100" value="80" color="success" />
                        </div> */}
                        {/* <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                          <i className="ni ni-istanbul" />
                        </div>
                        <h6 className="text-success text-uppercase">
                          Build Something
                          </h6>
                        <p className="description mt-3">
                          Argon is a great free UI package based on Bootstrap
                          4 that includes the most important components and
                          features.
                          </p>
                        <div>
                          <Badge color="success" pill className="mr-1">
                            business
                            </Badge>
                          <Badge color="success" pill className="mr-1">
                            vision
                            </Badge>
                          <Badge color="success" pill className="mr-1">
                            success
                            </Badge>
                        </div>
                        <Button
                          className="mt-4"
                          color="success"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Learn more
                          </Button> */}
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="4">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        {/* <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                          <i className="ni ni-planet" />
                        </div>
                        <h6 className="text-warning text-uppercase">
                          Prepare Launch
                          </h6>
                        <p className="description mt-3">
                          Argon is a great free UI package based on Bootstrap
                          4 that includes the most important components and
                          features.
                          </p>
                        <div>
                          <Badge color="warning" pill className="mr-1">
                            marketing
                            </Badge>
                          <Badge color="warning" pill className="mr-1">
                            product
                            </Badge>
                          <Badge color="warning" pill className="mr-1">
                            launch
                            </Badge>
                        </div>
                        <Button
                          className="mt-4"
                          color="warning"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Learn more
                          </Button> */}
                        <div className="progress-wrapper">
                          <div className="progress-info">
                            <div className="progress-label">
                              <span>DevOps & Cloud Technologies</span>
                            </div>
                            <div className="progress-percentage">
                              <span>70%</span>
                            </div>
                          </div>
                          <Progress max="100" value="60" color="primary" />
                        </div>
                        <div className="progress-wrapper">
                          <div className="progress-inpfo">
                            <div className="progress-label">
                              <span>Monitoring & Deployments</span>
                            </div>
                            <div className="progress-percentage">
                              <span>70%</span>
                            </div>
                          </div>
                          <Progress max="100" value="70" color="info" />
                        </div>
                        {/* <div className="progress-wrapper">
                          <div className="progress-info">
                            <div className="progress-label">
                              <span>HTML/CSS/BOOTSTRAP</span>
                            </div>
                            <div className="progress-percentage">
                              <span>80%</span>
                            </div>
                          </div>
                          <Progress max="100" value="80" color="success" />
                        </div> */}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
        {/* <section className="section section-lg pt-lg-0 mt--200">
          <Container>
            <Row className="justify-content-center">
              <Col lg="12">
                <Row className="row-grid">
                  <Col lg="4">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                          <i className="ni ni-check-bold" />
                        </div>
                        <h6 className="text-primary text-uppercase">
                          Download Argon
                          </h6>
                        <p className="description mt-3">
                          Argon is a great free UI package based on Bootstrap
                          4 that includes the most important components and
                          features.
                          </p>
                        <div>
                          <Badge color="primary" pill className="mr-1">
                            design
                            </Badge>
                          <Badge color="primary" pill className="mr-1">
                            system
                            </Badge>
                          <Badge color="primary" pill className="mr-1">
                            creative
                            </Badge>
                        </div>
                        <Button
                          className="mt-4"
                          color="primary"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Learn more
                          </Button>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="4">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                          <i className="ni ni-istanbul" />
                        </div>
                        <h6 className="text-success text-uppercase">
                          Build Something
                          </h6>
                        <p className="description mt-3">
                          Argon is a great free UI package based on Bootstrap
                          4 that includes the most important components and
                          features.
                          </p>
                        <div>
                          <Badge color="success" pill className="mr-1">
                            business
                            </Badge>
                          <Badge color="success" pill className="mr-1">
                            vision
                            </Badge>
                          <Badge color="success" pill className="mr-1">
                            success
                            </Badge>
                        </div>
                        <Button
                          className="mt-4"
                          color="success"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Learn more
                          </Button>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="4">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                          <i className="ni ni-planet" />
                        </div>
                        <h6 className="text-warning text-uppercase">
                          Prepare Launch
                          </h6>
                        <p className="description mt-3">
                          Argon is a great free UI package based on Bootstrap
                          4 that includes the most important components and
                          features.
                          </p>
                        <div>
                          <Badge color="warning" pill className="mr-1">
                            marketing
                            </Badge>
                          <Badge color="warning" pill className="mr-1">
                            product
                            </Badge>
                          <Badge color="warning" pill className="mr-1">
                            launch
                            </Badge>
                        </div>
                        <Button
                          className="mt-4"
                          color="warning"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Learn more
                          </Button>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section> */}
        <section className="section bg-secondary">
          <Container>
            <Row className="row-grid align-items-center">
              <Col md="6">
                <Card className="bg-default shadow border-0 floating">
                  <CardImg
                    alt="..."
                    src={require("assets/img/theme/DCXIdeathon_Mahesh_Bhusanoor_Capgemini.png")}
                    top
                  />
                  <blockquote className="card-blockquote">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="svg-bg"
                      preserveAspectRatio="none"
                      viewBox="0 0 583 95"
                    >
                      <polygon
                        className="fill-default"
                        points="0,52 583,95 0,95"
                      />
                      <polygon
                        className="fill-default"
                        opacity=".2"
                        points="0,42 583,95 683,0 0,95"
                      />
                    </svg>
                    <h4 className="display-3 font-weight-bold text-white">
                      Work Summary
                    </h4>
                    <p className="lead text-italic text-white">
                      {this.calculate_age("06/02/2014")}+ years of experience in
                      Mobile, Web, Azure, Docker, Kubernates, NodeJs, DevOps,
                      BFF, Portal, and PWA.
                    </p>
                  </blockquote>
                </Card>
              </Col>
              <Col md="6">
                <div className="pl-md-5">
                  <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                    <i className="ni ni-satisfied" />
                  </div>
                  <h3>Summary</h3>
                  {/* <p className="lead">
                  Working on frameworks like React-Native, React JS, Redux, Ionic, Cordova, IBM Mobile First, JavaScript, Node JS, Firebase, Electron, Typescript and Angular2+.
                    </p> */}
                  <p>
                    Working experience on frameworks like React-Native, React
                    JS, Redux (Thunk, SAGA & Observables), Ionic, Capacitor,
                    Node JS, Express Js, DevOps, Azure, CICD, AWS, Java, Docker,
                    Kubernates,Android Native, PhoneGap/Cordova, Fastlane, IBM
                    Mobile First, JavaScript, Firebase, Typescript and
                    Angular2+.
                  </p>
                  <p>
                    Working experience in CICD tools like Bitrise, Jenkins &
                    Fastlane.
                  </p>
                  <p>
                    Have good exposure to Code Quality Assurance tools like
                    Codacy & SonarQube.
                  </p>

                  <p>
                    Have good exposure on hosting websites, Design Thinking,
                    Digital Marketing, Google Analytics, SEO, Google AdWords and
                    Google AdSense.
                  </p>
                  <p>
                    Self-motivated, with the drive and initiative to carry out
                    projects according to plan, and the ability to quickly adapt
                    in a fast-changing environment.
                  </p>
                  {/* <a
                    className="font-weight-bold text-warning mt-5"
                    href="#pablo"
                    onClick={e => e.preventDefault()}
                  >
                    A beautiful UI Kit for impactful websites
                    </a> */}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section pb-0 bg-gradient-warning">
          <Container>
            <Row className="row-grid align-items-center">
              <Col className="order-lg-2 ml-lg-auto" md="6">
                <div className="position-relative pl-md-5 floating">
                  <img
                    alt="..."
                    className="img-center img-fluid"
                    src={require("assets/img/theme/Antraweb.jpg")}
                  />
                </div>
              </Col>
              <Col className="order-lg-1" lg="6">
                <div className="d-flex px-3">
                  <div>
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                      <i className="ni ni-building text-primary" />
                    </div>
                  </div>
                  <div className="pl-4">
                    <h4 className="display-3 text-white">Work Experience</h4>
                    {/* <p className="text-white">
                      The Arctic Ocean freezes every winter and much of the
                      sea-ice then thaws every summer, and that process will
                      continue whatever.
                      </p> */}
                  </div>
                </div>
                <Card className="shadow shadow-lg--hover mt-5">
                  <CardBody>
                    <div className="d-flex px-3">
                      <div>
                        <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <i className="ni ni-satisfied" />
                        </div>
                      </div>
                      <div className="pl-4">
                        <h5 className="title text-success">
                          <a href="https://www.capgemini.com/in-en/">
                            Capgemini UAE - Dubai
                          </a>
                        </h5>
                        <p>Technical Lead</p>
                        {/* <p>
                          The Arctic Ocean freezes every winter and much of
                          the sea-ice then thaws every summer, and that
                          process will continue whatever.
                          </p>
                        <a
                          className="text-success"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Learn more
                          </a> */}
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <Card className="shadow shadow-lg--hover mt-5">
                  <CardBody>
                    <div className="d-flex px-3">
                      <div>
                        <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <i className="ni ni-satisfied" />
                        </div>
                      </div>
                      <div className="pl-4">
                        <h5 className="title text-warning">
                          <a href="https://www.ibm.com/in-en">
                            IBM India Private Limited
                          </a>
                        </h5>
                        <p>Application Developer</p>
                        {/* <p>
                          The Arctic Ocean freezes every winter and much of
                          the sea-ice then thaws every summer, and that
                          process will continue whatever.
                          </p>
                        <a
                          className="text-warning"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Learn more
                          </a> */}
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <Card className="shadow shadow-lg--hover mt-5">
                  <CardBody>
                    <div className="d-flex px-3">
                      <div>
                        <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <i className="ni ni-satisfied" />
                        </div>
                      </div>
                      <div className="pl-4">
                        <h5 className="title text-warning">
                          <a href="https://www.antraweb.com/">
                            Antraweb Technologies
                          </a>
                        </h5>
                        <p>Research and Development Engineer</p>
                        {/* <p>
                          The Arctic Ocean freezes every winter and much of
                          the sea-ice then thaws every summer, and that
                          process will continue whatever.
                          </p>
                        <a
                          className="text-warning"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Learn more
                          </a> */}
                      </div>
                    </div>
                  </CardBody>
                </Card>
                {/* <Card className="shadow shadow-lg--hover mt-5">
                  <CardBody>
                    <div className="d-flex px-3">
                      <div>
                        <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <i className="ni ni-active-40" />
                        </div>
                      </div>
                      <div className="pl-4">
                        <h5 className="title text-warning">
                        Technophilia Systems
                          </h5>
                         <p>
                         Android Developer
                          </p>
                      <a
                          className="text-warning"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Learn more
                          </a> 
                      </div>
                    </div>
                  </CardBody>
                </Card> */}
              </Col>
            </Row>
          </Container>
          {/* SVG separator */}
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon className="fill-white" points="2560 0 2560 100 0 100" />
            </svg>
          </div>
        </section>
        <section className="section section-lg">
          <Container>
            <Row className="justify-content-center text-center mb-lg">
              <Col lg="8">
                <h2 className="display-3">My Achievements</h2>
                <p className="lead text-muted">
                  You only need to find yourself, everything else can be
                  Googled.
                </p>
              </Col>
            </Row>
            <Row>
              <Col className="mb-5 mb-lg-0" lg="3" md="6">
                <div className="px-4 text-center">
                  {/* <img
                    alt="..."
                    className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                    src={require("assets/img/theme/team-1-800x800.jpg")}
                    style={{ width: "200px" }}
                  /> */}
                  <div
                    data-iframe-width="180"
                    data-iframe-height="270"
                    data-share-badge-id="d3236d55-366c-45f4-9c9a-f509159d566e"
                  ></div>
                </div>
              </Col>
              <Col className="mb-5 mb-lg-0" lg="3" md="6">
                <div className="px-4 text-center">
                  <div
                    data-iframe-width="180"
                    data-iframe-height="270"
                    data-share-badge-id="2f159fd7-5a04-4c19-9628-1bbe13af720d"
                  ></div>
                </div>
              </Col>
              <Col className="mb-5 mb-lg-0" lg="3" md="6">
                <div className="px-4 text-center">
                  <div
                    data-iframe-width="180"
                    data-iframe-height="270"
                    data-share-badge-id="dcd61f2f-3745-4c43-b0c7-39fc504490aa"
                  ></div>
                </div>
              </Col>
              <Col className="mb-5 mb-lg-0" lg="3" md="6">
                <div className="px-4 text-center">
                  <div
                    data-iframe-width="180"
                    data-iframe-height="270"
                    data-share-badge-id="b934a8a2-18fd-41b6-82c3-ea46392767bd"
                  ></div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="mb-5 mb-lg-0" lg="4" md="4">
                <div className="px-4">
                  <img
                    alt="..."
                    className="rounded img-center img-fluid shadow shadow-lg--hover"
                    src={require("assets/img/theme/Customer Delight Award 2021.png")}
                    style={{ width: "300px" }}
                  />
                  <div className="pt-4 text-center">
                    <h5 className="title">
                      <span className="d-block mb-1">
                        Digital Diamonds : Customer Delight Award
                      </span>
                      {/* <small className="h6 text-muted">UI/UX Designer</small> */}
                    </h5>
                    {/* <div className="mt-3">
                      <Button
                        className="btn-icon-only rounded-circle"
                        color="info"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        <i className="fa fa-twitter" />
                      </Button>
                      <Button
                        className="btn-icon-only rounded-circle ml-1"
                        color="info"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        <i className="fa fa-facebook" />
                      </Button>
                      <Button
                        className="btn-icon-only rounded-circle ml-1"
                        color="info"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        <i className="fa fa-dribbble" />
                      </Button>
                    </div> */}
                  </div>
                </div>
              </Col>
              <Col className="mb-5 mb-lg-0" lg="4" md="4">
                <div className="px-4">
                  <img
                    alt="..."
                    className="rounded img-center img-fluid shadow shadow-lg--hover"
                    src={require("assets/img/theme/Mahesh Bhusanoor Project Star Award At Capgemini India Services.jpg")}
                    style={{ width: "300px" }}
                  />
                  <div className="pt-4 text-center">
                    <h5 className="title">
                      <span className="d-block mb-1">
                        Digital Diamonds : Project Star Award
                      </span>
                      {/* <small className="h6 text-muted">UI/UX Designer</small> */}
                    </h5>
                    {/* <div className="mt-3">
                      <Button
                        className="btn-icon-only rounded-circle"
                        color="info"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        <i className="fa fa-twitter" />
                      </Button>
                      <Button
                        className="btn-icon-only rounded-circle ml-1"
                        color="info"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        <i className="fa fa-facebook" />
                      </Button>
                      <Button
                        className="btn-icon-only rounded-circle ml-1"
                        color="info"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        <i className="fa fa-dribbble" />
                      </Button>
                    </div> */}
                  </div>
                </div>
              </Col>
              <Col className="mb-5 mb-lg-0" lg="4" md="4">
                <div className="px-4">
                  <img
                    alt="..."
                    className="rounded img-center img-fluid shadow shadow-lg--hover"
                    src={require("assets/img/theme/Mahesh Bhusanoor- The fundamentals of digital marketing.jpg")}
                    style={{ width: "300px" }}
                  />
                  <div className="pt-4 text-center">
                    <h5 className="title">
                      <span className="d-block mb-1">
                        The fundamentals of digital marketing
                      </span>
                      {/* <small className="h6 text-muted">Founder and CEO</small> */}
                    </h5>
                    {/* <div className="mt-3">
                      <Button
                        className="btn-icon-only rounded-circle"
                        color="success"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        <i className="fa fa-twitter" />
                      </Button>
                      <Button
                        className="btn-icon-only rounded-circle ml-1"
                        color="success"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        <i className="fa fa-facebook" />
                      </Button>
                      <Button
                        className="btn-icon-only rounded-circle ml-1"
                        color="success"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        <i className="fa fa-dribbble" />
                      </Button>
                    </div> */}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="mb-5 mb-lg-0" lg="4" md="4">
                <div className="px-4">
                  <img
                    alt="..."
                    className="rounded img-center img-fluid shadow shadow-lg--hover"
                    src={require("assets/img/theme/Google Analytics Individual Qualification.png")}
                    style={{ width: "300px" }}
                  />
                  <div className="pt-4 text-center">
                    <h5 className="title">
                      <span className="d-block mb-1">
                        Google Analytics Individual Qualification
                      </span>
                      {/* <small className="h6 text-muted">UI/UX Designer</small> */}
                    </h5>
                  </div>
                </div>
              </Col>
              <Col className="mb-5 mb-lg-0" lg="4" md="4">
                <div className="px-4">
                  <img
                    alt="..."
                    className="rounded img-center img-fluid shadow shadow-lg--hover"
                    src={require("assets/img/theme/Agile with Atlassian Jira.png")}
                    style={{ width: "300px" }}
                  />
                  <div className="pt-4 text-center">
                    <h5 className="title">
                      <span className="d-block mb-1">
                        Agile with Atlassian Jira
                      </span>
                      {/* <small className="h6 text-muted">UI/UX Designer</small> */}
                    </h5>
                  </div>
                </div>
              </Col>
              <Col className="mb-5 mb-lg-0" lg="4" md="4">
                <div className="px-4">
                  <img
                    alt="..."
                    className="rounded img-center img-fluid shadow shadow-lg--hover"
                    src={require("assets/img/theme/AWS Fundamentals Going Cloud-Native.png")}
                    style={{ width: "300px" }}
                  />
                  <div className="pt-4 text-center">
                    <h5 className="title">
                      <span className="d-block mb-1">
                        AWS Fundamentals Going Cloud-Native
                      </span>
                      {/* <small className="h6 text-muted">Founder and CEO</small> */}
                    </h5>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* <section className="section section-shaped">
          <div className="shape shape-style-1 shape-default">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
           <Container className="py-md">
            <Row className="justify-content-between align-items-center">
              <Col className="mb-5 mb-lg-0" lg="5">
                <h1 className="text-white font-weight-light">My Expertise</h1>
                <p className="lead text-white">
                  Skilled in Mobile, Web, Portal and PWA Applications. Have
                  strong experience on Research & Development.
                </p>
                <Card className="shadow shadow-lg--hover mt-5">
                  <CardBody>
                    <div className="d-flex px-3">
                      <div>
                        <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <i className="ni ni-satisfied" />
                        </div>
                      </div>
                      <div className="pl-4">
                        <h5 className="title text-warning">
                          Mobile Applications
                        </h5>
                        <p>Android, IOS and Windows</p>
                       
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <Card className="shadow shadow-lg--hover mt-5">
                  <CardBody>
                    <div className="d-flex px-3">
                      <div>
                        <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <i className="ni ni-satisfied" />
                        </div>
                      </div>
                      <div className="pl-4">
                        <h5 className="title text-warning">Blogger</h5>
                        <p>Technical & Motivational</p>
                       
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col className="mb-lg-auto" lg="6">
                <Card className="shadow shadow-lg--hover mt-5">
                  <CardBody>
                    <div className="d-flex px-3">
                      <div>
                        <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <i className="ni ni-satisfied" />
                        </div>
                      </div>
                      <div className="pl-4">
                        <h5 className="title text-warning">Web Applications</h5>
                        <p>Progressive Web Apps</p>
                      
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <Card className="shadow shadow-lg--hover mt-5">
                  <CardBody>
                    <div className="d-flex px-3">
                      <div>
                        <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <i className="ni ni-satisfied" />
                        </div>
                      </div>
                      <div className="pl-4">
                        <h5 className="title text-warning">
                          Technical Trainings
                        </h5>
                        <p>Robotics, Mobile and Web Applications</p>
                      
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container> 
         
          <div className="separator separator-bottom separator-skew">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon className="fill-white" points="2560 0 2560 100 0 100" />
            </svg>
          </div>
        </section>
        */}
        <section className="section section-lg pt-0">
          <Container>
            <Card className="bg-gradient-warning shadow-lg border-0">
              <div className="p-5">
                <Row className="align-items-center text-center">
                  <Col lg="12">
                    <h3 className="text-white">
                      <div>
                        <Badge className="badge-circle mr-3" color="warning">
                          <i className="ni ni-satisfied" />
                        </Badge>
                        Best lines by ME!
                      </div>
                    </h3>
                    <p className="lead text-white mt-3">
                      When you are afraid of doing something in life, just go
                      for it. Even if you fail to do it, you will be ahead of
                      the people who are afraid of doing the same thing.
                      {/* <br/> <div><Badge
                            className="badge-circle mr-3"
                            color="success"
                          >
                            <i className="ni ni-satisfied" />
                          </Badge>
                        </div> */}
                    </p>
                    <p className="lead text-white mt-3 text-right">
                      - Mahesh Bhusanoor
                    </p>
                  </Col>
                </Row>
              </div>
            </Card>
          </Container>
        </section>
        {/* <section className="section section-lg pt-0">
          <Container>
            <Card className="bg-gradient-warning shadow-lg border-0">
              <div className="p-5">
                <Row className="align-items-center">
                  <Col lg="8">
                    <h3 className="text-white">
                      We made website building easier for you.
                      
                      </h3>
                    <p className="lead text-white mt-3">
                      I will be the leader of a company that ends up being
                      worth billions of dollars, because I got the answers. I
                      understand culture.
                      </p>
                    
                  </Col>
                  <Col className="ml-lg-auto" lg="3">
                    <Button
                      block
                      className="btn-white"
                      color="default"
                      href="https://www.creative-tim.com/product/argon-design-system-react?ref=adsr-landing-page"
                      size="lg"
                    >
                      Download React
                      </Button>
                  </Col>
                </Row>
              </div>
            </Card>
          </Container>
        </section> */}
        <section className="section section-lg">
          <Container>
            <Row className="row-grid align-items-center">
              <Col className="order-md-2" md="6">
                <div className="pr-md-5">
                  <div className="icon icon-lg icon-shape icon-shape-success shadow rounded-circle mb-5">
                    <i className="ni ni-books" />
                  </div>
                  <h3>My Blogs</h3>
                  <p>
                    No one who does good work will ever come to a bad end,
                    either here or in the world to come - Bhagavat Gita
                  </p>
                </div>
                {/* <img
                    alt="..."
                    className="img-fluid floating"
                    src={require("assets/img/theme/promo-1.png")}
                  /> */}
                <Card className="shadow shadow-lg--hover mt-5 floating">
                  <CardBody>
                    <div className="d-flex px-3">
                      <div>
                        <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <i className="ni ni-satisfied" />
                        </div>
                      </div>
                      <div className="pl-4">
                        <h5 className="title text-success">
                          <a
                            title="Data Science Is The Sexiest Job In The 21st Century"
                            href="https://www.maheshbhusanoor.com/article/data-science-sexiest-job-in-the-21st-century.html"
                          >
                            Data Science Is The Sexiest Job In The 21st Century
                          </a>
                        </h5>
                        <p>
                          Data Science Is Relevant Today Because We Have Tons Of
                          Data Available...
                        </p>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col className="order-md-1" md="6">
                <Card className="shadow shadow-lg--hover mt-5 floating">
                  <CardBody>
                    <div className="d-flex px-3">
                      <div>
                        <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <i className="ni ni-satisfied" />
                        </div>
                      </div>
                      <div className="pl-4">
                        <h5 className="title text-success">
                          <a
                            title="Most Asked Ionic Interview Questions"
                            href="https://www.maheshbhusanoor.com/article/ionic-interview-questions-answers.html"
                          >
                            Most Asked Hybrid Mobile App Developer Interview
                            Questions
                          </a>
                        </h5>
                        <p>
                          Top 100 Ionic Interview Questions- Interview Question
                          answer for Ionic Developer, Hybrid Mobile App
                          Developer and Cordova Developer.
                        </p>
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <Card className="shadow shadow-lg--hover mt-5 floating">
                  <CardBody>
                    <div className="d-flex px-3">
                      <div>
                        <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <i className="ni ni-satisfied" />
                        </div>
                      </div>
                      <div className="pl-4">
                        <h5 className="title text-success">
                          <a
                            title="Top 100 React & Redux Interview Question Answers"
                            href="https://www.maheshbhusanoor.com/article/top-100-react-redux-interview-question-answers.html"
                          >
                            Top 100 React & Redux Interview Question Answers
                          </a>
                        </h5>
                        <p>
                          Top 100 React & Redux Interview Question Answers for
                          React Developer.
                        </p>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section section-shaped">
          <div className="shape shape-style-1 shape-default">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <Container className="py-md">
            <Row className="justify-content-between align-items-center">
              <Col className="mb-5 mb-lg-0" lg="5">
                <h1 className="text-white font-weight-light">Contact Info</h1>
                {/* <p className="lead text-white mt-4">
                  I have conducted 40+ Technical workshops on Engineering colleges all over India. Educated more than 5000+ Students all over India. Including IITs and NITs.
                </p> */}
                <p className="lead text-white">
                  Mobile : +918007340209
                  <br />
                  Email : Maheshbhusanoor@gmail.com
                  <br />
                  Location : Mumbai, Maharashtra, India.
                </p>
                {/* <Button
                  className="btn-white mt-4"
                  color="default"
                  href="https://demos.creative-tim.com/argon-design-system-react/#/documentation/alerts?ref=adsr-landing-page"
                >
                  See all components
                </Button> */}
              </Col>
              <Col className="mb-lg-auto" lg="6">
                <Card className="bg-gradient-secondary shadow">
                  <CardBody className="p-lg-5">
                    <h4 className="mb-1">Get in touch?</h4>
                    {/* <p className="mt-0">
                      Your project is very important to us.
                      </p> */}
                    <FormGroup
                      className={classnames("mt-5", {
                        focused: this.state.nameFocused,
                      })}
                    >
                      <InputGroup className="input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-user-run" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Your name"
                          type="text"
                          value={this.state.name}
                          onFocus={(e) => this.setState({ nameFocused: true })}
                          onBlur={(e) => this.setState({ nameFocused: false })}
                          onChange={(event) =>
                            this.setState({ name: event.target.value })
                          }
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup
                      className={classnames({
                        focused: this.state.emailFocused,
                      })}
                    >
                      <InputGroup className="input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-email-83" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Email address"
                          type="email"
                          value={this.state.email}
                          onFocus={(e) => this.setState({ emailFocused: true })}
                          onBlur={(e) => this.setState({ emailFocused: false })}
                          onChange={(event) =>
                            this.setState({ email: event.target.value })
                          }
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup className="mb-4">
                      <Input
                        className="form-control-alternative"
                        cols="80"
                        name="name"
                        value={this.state.message}
                        placeholder="Type a message..."
                        rows="4"
                        type="textarea"
                        onChange={(event) =>
                          this.setState({ message: event.target.value })
                        }
                      />
                    </FormGroup>
                    <div>
                      <Button
                        block
                        className="btn-round"
                        color="default"
                        size="lg"
                        type="button"
                        onClick={this.submitQuery}
                      >
                        Send Message
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
          {/* SVG separator */}
          <div className="separator separator-bottom separator-skew">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon className="fill-white" points="2560 0 2560 100 0 100" />
            </svg>
          </div>
        </section>
        <SimpleFooter />
      </>
    );
  }
}

export default Profile;
